import React from 'react'

import DeleteIcon from '@mui/icons-material/Delete'
import { Button, Grid } from '@mui/material'

import { FormTextField } from 'components/input'
import NameDoDomainFormNameField from 'components/name-to-domain/NameDoDomainFormNameField'

type NameToDomainMappingProps = {
  index: number
  onRowRemove: (...args: any[]) => any
}

const NameToDomainMapping = ({ onRowRemove, index }: NameToDomainMappingProps) => (
  <Grid container spacing={2}>
    <Grid
      size={{
        sm: 5,
      }}>
      <NameDoDomainFormNameField name={`mappings[${index}].name`} />
    </Grid>
    <Grid
      size={{
        sm: 5,
      }}>
      <FormTextField name={`mappings[${index}].domain`} placeholder="Domain" />
    </Grid>

    <Grid
      size={{
        sm: 2,
      }}>
      <Button onClick={onRowRemove}>
        <DeleteIcon />
      </Button>
    </Grid>
  </Grid>
)

export default NameToDomainMapping
